import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Modal } from "@/Common/Components/Modals/Modal";

interface ISimplePdfPreviewPopupProps {
    sourceUrl: string;
    title?: string;
    footer?: JSX.Element;
    onClose: () => void;
}

class SimplePdfPreviewPopup extends BaseReactComponent<ISimplePdfPreviewPopupProps> {
    public render(): JSX.Element {
        return (
            <Modal
                id="simple_pdf_preview"
                dataCy="simplePDFPreview-modal"
                title={this.props.title || ""}
                onClose={() => this.props.onClose && this.props.onClose()}
                footer={this.props.footer}
                top={60}
                width={580}
                showOverlay
                showX
                disableOverlayClose
                roundTopCorner
                draggable
            >
                <div className="generic-print-sign-popup">
                    <div className="p-body">
                        <iframe
                            id="iframe-pdf-document"
                            src={`${this.props.sourceUrl}&_nocache=${sessionStore.newId()}`}
                            height="730"
                            width="540"
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

export { SimplePdfPreviewPopup };
